import { takeEvery, put, call, select } from "redux-saga/effects";

import * as action from "./actions";
import { actions as commonActions } from "../common";
import { actions as reportActions } from "../Report";
import * as api from "../../apis";
import { message } from "antd";

import { user_id, currentUserIsInternal } from "../User/selectors";
import { currentMerchantName } from "../Merchant/selectors";

// seconds
const MESSAGE_DURATION = 5;

export function* getSchema() {
  try {
    let response = yield call(api.fetchSchema);
    yield put(action.addSchema(response));
  } catch (e) {
    alert(e);
  }
}

export function* watchGetSchema() {
  yield takeEvery(action.GET_SCHEMA, getSchema);
}

export function* submitForm(request) {
  try {
    let { merchant_id, form, sendAfter } = request.payload;
    let userId = select(user_id);

    const report = yield call(api.createReport, merchant_id, form);
    yield put(action.submitFormSuccess(request.payload));

    const merchant_name = yield select(currentMerchantName, merchant_id);
    let internal = yield select(currentUserIsInternal);
    if (userId && merchant_name) {
      const company_type = internal ? "Internal" : "External";
      yield window.ga(
        "send",
        "event",
        "Saved New Report - " + company_type,
        merchant_name,
        userId
      );
    }

    if (sendAfter)
      yield put(reportActions.sendLatestReport(merchant_id, report.id));
    else {
      message.config({
        top: 70
      });
      message.success(
        `Your report named "${request.payload.form.format.name}" has been successfully created`,
        MESSAGE_DURATION
      );
    }

    yield put(commonActions.redirectTo(`/merchants/${merchant_id}`));
  } catch (e) {
    alert(e);
    yield put(action.submitFormFailure());
  }
}

export function* watchSubmitForm() {
  yield takeEvery(action.SUBMIT_FORM, submitForm);
}

// TODO this needs to be named more consistently
// between action//type//sagas
export function* editForm(request) {
  try {
    let { merchant_id, report_id, form, sendAfter } = request.payload;
    let userId = select(user_id);

    yield call(api.updateReport, merchant_id, report_id, form);
    yield put(action.editFormSuccess(request.payload));

    const merchant_name = yield select(currentMerchantName, merchant_id);
    let internal = yield select(currentUserIsInternal);
    if (userId && merchant_name) {
      const company_type = internal ? "Internal" : "External";
      yield window.ga(
        "send",
        "event",
        "Edited Report - " + company_type,
        merchant_name,
        userId
      );
    }

    if (sendAfter)
      yield put(reportActions.sendLatestReport(merchant_id, report_id));
    else {
      message.config({
        top: 70
      });
      message.success(
        `Your report named "${request.payload.form.format.name}" has been successfully updated`,
        MESSAGE_DURATION
      );
    }

    yield put(commonActions.redirectTo(`/merchants/${merchant_id}`));
  } catch (e) {
    alert(e);
    yield put(action.editFormFailure());
  }
}

export function* watchEditForm() {
  yield takeEvery(action.EDIT_REPORT, editForm);
}

export function* getReport(request) {
  try {
    let { merchant_id, report_id } = request.payload;
    let response = yield call(api.readReport, merchant_id, report_id);
    yield put(action.addReport(response));
  } catch (e) {
    alert(e);
  }
}

export function* watchGetReport() {
  yield takeEvery(action.GET_REPORT, getReport);
}

export function* createReport(request) {
  let userId = yield select(user_id);

  const merchant_name = yield select(
    currentMerchantName,
    request.payload.merchant_id
  );
  let internal = yield select(currentUserIsInternal);
  if (userId && merchant_name) {
    const company_type = internal ? "Internal" : "External";
    yield window.ga(
      "send",
      "event",
      "Create New Report - " + company_type,
      merchant_name,
      userId
    );
  }
}

export function* watchCreateReport() {
  yield takeEvery(action.CREATE_REPORT, createReport);
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/sagas.js